import { apiPatch } from "./apiRequest";

const freezeDeviceService = async (category, freezeValue, deviceId, userId, deviceType) =>
    apiPatch(`/${category}/update-device/${deviceId}`, {
        freeze: freezeValue,
        ...(category === 'switches' && { freeze_by: userId }),
        ...(category === 'blowers' && {
            deviceType,
            ...(deviceType === 'TGS' && { freeze_by: userId }),
            ...(deviceType === 'TES' && { e_freeze_by: userId }),
        }),
    });

export const freezeSwitchDeviceService = (freezeValue, deviceId, userId) =>
    freezeDeviceService("switches", freezeValue, deviceId, userId);

export const freezeBlowerDeviceService = (freezeValue, deviceId, userId, deviceType) =>
    freezeDeviceService("blowers", freezeValue, deviceId, userId, deviceType);
